import { Link } from "react-router-dom";
import Rules from "./Rules";

const PageRoot = () => {
  return (
    <div className="bg-blue w-full min-w-full min-h-screen font-primary">
      <header className="w-full flex justify-center py-10 text-3xl text-black font-semibold">
        <h1>Three Doors Problem</h1>
      </header>
      <div className="w-full">
        <div className="mx-1 lg:mx-20 space-y-16 flex flex-col items-center">
          <Rules />
          <div className="grid grid-cols-2 gap-10">
            <Link className="button-primary-big" to={"/manual"}>
              Manual
            </Link>
            <Link className="button-primary-big" to={"/auto"}>
              Auto
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PageRoot;